import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const AUTH_URL = `${API_URL}/authRoutes`;

// Get auth token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const roleService = {
  // Get all roles with pagination and search
  getAllRoles: async ({ page = 1, limit = 5, search = '' } = {}) => {
    try {
      const response = await axios.get(`${AUTH_URL}/roles`, {
        headers: getAuthHeader(),
        params: { page, limit, search }
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch roles' };
    }
  },

  // Get role by ID with permissions
  getRoleById: async (roleId) => {
    try {
      const response = await axios.get(`${AUTH_URL}/roles/${roleId}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch role' };
    }
  },

  // Create new role
  createRole: async (roleData) => {
    try {
      const response = await axios.post(`${AUTH_URL}/roles`, roleData, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create role' };
    }
  },

  // Update role
  updateRole: async (roleId, roleData) => {
    try {
      const response = await axios.put(`${AUTH_URL}/roles/${roleId}`, roleData, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update role' };
    }
  },

  // Delete role
  deleteRole: async (roleId) => {
    try {
      const response = await axios.delete(`${AUTH_URL}/roles/${roleId}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete role' };
    }
  },

  // Get all permissions
  // Note: This fetches up to 10000 permissions for client-side filtering.
  // If you have more permissions, consider implementing server-side search/pagination.
  getAllPermissions: async () => {
    try {
      const response = await axios.get(`${AUTH_URL}/permissions`, {
        headers: getAuthHeader(),
        params: { limit: 10000 } // Get all permissions for client-side filtering
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch permissions' };
    }
  },

  // Assign permission to role
  assignPermissionToRole: async (roleId, permissionId) => {
    try {
      const response = await axios.post(`${AUTH_URL}/roles/${roleId}/permissions`,
        { permissionId },
        { headers: getAuthHeader() }
      );
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to assign permission' };
    }
  },

  // Remove permission from role
  removePermissionFromRole: async (roleId, permissionId) => {
    try {
      const response = await axios.delete(`${AUTH_URL}/roles/${roleId}/permissions/${permissionId}`, {
        headers: getAuthHeader()
      });
      return { success: true, data: response.data };
    } catch (error) {
      throw error.response?.data || { message: 'Failed to remove permission' };
    }
  }
};

export default roleService;
